import { createTheme } from "@mui/material/styles";

const data = {
  name: "好先生",
  gender: "男",
  gender_label: "乾造",
  birthday_greg: "2025年12月30日 18:02:59",
  birthday_chinese: "2025年腊月廿八 18:05:34",
};
const titleList = ["乾造", "年柱", "月柱", "日柱", "时柱"];
const tianGanList = ["天干", "丙", "辛", "乙", "庚"];
const diZhiList = ["地支", "子", "丑", "卯", "辰"];
const cangGanList = [
  "藏干",
  "癸",
  ["己", "癸", "辛"],
  "乙",
  ["戊", "乙", "癸"],
];
const zhuXingList = ["主星", "伤官", "七杀", "元男", "正官"];
const fuXingList = [
  "副星",
  "偏印",
  ["偏财", "偏印", "七杀"],
  "比肩",
  ["正财", "比肩", "偏印"],
];

const xingYunList = ["星运", "病", "衰", "临官", "冠带"];
const ziZuoList = ["自坐", "胎", "养", "临官", "养"];
const kongWangList = ["空亡", "申酉", "辰巳", "子丑", "申酉"];
const naYinList = ["纳音", "涧下水", "壁上土", "大溪水", "白腊金"];
const shenShaList = [
  "神煞",
  ["天乙贵人", "太极贵人", "天医", "桃花", "血刃", "空亡"],
  ["空亡", "国印"],
  ["太极贵人", "天德合", "月德合", "勾绞煞", "童子煞", "禄神", "红鸾", "八专"],

  ["天德贵人", "月德贵人", "华盖", "地网"],
];

// 创建一个完整的主题配置
const baZiTheme = createTheme({
  palette: {
    primary: {
      main: "#B2955D", // rgb(178,149,93)
      light: "#C6AF7F", // +10% 白
      dark: "#8E774A", // −15% 黑
      contrastText: "#000000",
    },
    secondary: {
      main: "#121212", // 纯金
      light: "#000000", // 10% 白
      dark: "#2D2D2D", // 15% 黑
      contrastText: "#B2955D", //
    },
    background: {
      paper: "#F5F0E8", // 暖白色：标题栏、卡片、头像
    },
  },
});

export {
  data,
  titleList,
  tianGanList,
  diZhiList,
  cangGanList,
  zhuXingList,
  fuXingList,
  xingYunList,
  ziZuoList,
  kongWangList,
  naYinList,
  shenShaList,
  baZiTheme,
};
